module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-student-box-image-6-7ae1aaf9309c8536874cdbce163ac186.jpg";